import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { FaAngleDown } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Navbar = ({ currentUser, batchTime, syncStatus }) => {
    const [showDropDown, setShowDropDown] = useState(false)

    const containerRef = useRef(null)
    const location = useLocation();
    const navigate = useNavigate();

    const dropDownRef = useRef(null);

    useEffect(() => {
        if (
            ["/users", "/create-user", "/filters"].includes(location.pathname) &&
            containerRef.current
        ) {
            const timeout = setTimeout(() => {
                const container = containerRef.current;
                container.scrollLeft = container.scrollWidth;
            }, 100); // 100ms delay

            return () => clearTimeout(timeout);
        }
    }, [location.pathname]);



    useEffect(() => {
        const handleInteraction = (event) => {
            if (
                dropDownRef &&
                dropDownRef.current &&
                !dropDownRef.current.contains(event.target)
            ) {
                setShowDropDown(false);
            }
        };

        document.addEventListener("mousedown", handleInteraction);
        document.addEventListener("touchstart", handleInteraction);
        document.addEventListener("touchmove", handleInteraction);
        document.addEventListener("wheel", handleInteraction);

        return () => {
            document.removeEventListener("mousedown", handleInteraction);
            document.removeEventListener("touchstart", handleInteraction);
            document.removeEventListener("touchmove", handleInteraction);
            document.removeEventListener("wheel", handleInteraction);
        };
    }, [showDropDown]);



    const handleNavigate = (path) => {
        navigate(path);
    };

    const handleDropDown = () => {
        setShowDropDown((prev) => !prev)
    };

    const isActive = (paths) => {
        if (Array.isArray(paths)) {
            return paths.includes(location.pathname);
        }
        return location.pathname === paths;
    };

    const handleStopBatch = async () => {
        try {
            let response = await axios.post(
                `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/stop-batch`,
                {},
                { withCredentials: true }
            )
            if (response.data.success) {
                toast.success(response.data.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to stop batch")
        }
    }

    return (
        <div ref={containerRef} className="flex justify-between items-center gap-4 overflow-x-scroll hide-scrollbar">
            <div className="flex gap-4 sm:px-2 xl:px-0 ">
                <button
                    onClick={() => handleNavigate("/recruiter-dashboard")}
                    className={`cursor-pointer  whitespace-nowrap font-medium text-[12px] leading-none tracking-[0px] pb-[2px] xl:pb-1 2xl:pb-2 px-[2px] xl:font-semibold xl:text-[14px] 2xl:text-[16px] ${isActive("/recruiter-dashboard")
                        ? "text-[#5D0E23] border-b-[2px] border-[#5D0E23]"
                        : "text-[#8d8d8d] border-b-[2px] border-[#F8F8F8]"}`}
                >
                    Recruiter Dashboard
                </button>
                <button
                    onClick={() => handleNavigate("/candidate-progress-dashboard")}
                    className={`cursor-pointer  whitespace-nowrap font-medium text-[12px] leading-none tracking-[0px] pb-[2px] xl:pb-1 2xl:pb-2 px-[2px] xl:font-semibold xl:text-[14px] 2xl:text-[16px] ${isActive("/candidate-progress-dashboard")
                        ? "text-[#5D0E23] border-b-[2px] border-[#5D0E23]"
                        : "text-[#8d8d8d] border-b-[2px] border-[#F8F8F8]"}`}
                >
                    Candidate Progress Dashboard
                </button>
                {currentUser.role === "admin" ? <div onClick={handleDropDown} className={`cursor-pointer  flex gap-[2px] whitespace-nowrap font-medium text-[12px] leading-none tracking-[0px] pb-[2px] xl:pb-1 2xl:pb-2 px-[2px] xl:font-semibold xl:text-[14px] 2xl:text-[16px]  ${isActive(["/users", "/create-user", "/filters"])
                    ? "text-[#5D0E23] border-b-[2px] border-[#5D0E23]"
                    : "text-[#8d8d8d] border-b-[2px] border-[#F8F8F8]"}`} >
                    <button className="cursor-pointer"
                    >
                        Admin
                    </button>
                    <div>
                        <FaAngleDown color={isActive(["/users", "/create-user", "/filters"]) ? "#5D0E23" : "#8d8d8d"} className="select-none" />
                    </div>
                    {showDropDown ? <div ref={dropDownRef} className="absolute right-[10px] sm:right-auto z-[999] mt-6  shadow-md rounded-[6px] overflow-hidden text-[#000000] text-[13px] font-normal bg-white border border-gray-300">
                        <Link
                            to="/users"
                            className={`block bg-white hover:bg-[#F5F5F5] cursor-pointer p-2 border-b border-gray-300 ${isActive("/users")
                                ? "text-[#5D0E23]"
                                : "text-[#000000]"
                                }`}
                        >
                            Users List
                        </Link>
                        <Link
                            to="/create-user"
                            className={`block bg-white hover:bg-[#F5F5F5] cursor-pointer p-2 border-b border-gray-300 ${isActive("/create-user")
                                ? "text-[#5D0E23]"
                                : "text-[#000000]"
                                }`}
                        >
                            Create User
                        </Link>
                        <Link
                            to="/filters"
                            className={`block bg-white hover:bg-[#F5F5F5] cursor-pointer p-2 border-b border-gray-300 ${isActive("/filters")
                                ? "text-[#5D0E23]"
                                : "text-[#000000]"
                                }`}
                        >
                            Filters
                        </Link>
                        <button
                            onClick={handleStopBatch}
                            className={`block bg-white hover:bg-[#F5F5F5] cursor-pointer p-2 border-b border-gray-300 ${isActive("/filters")
                                ? "text-[#5D0E23]"
                                : "text-[#000000]"
                                }`}
                        >
                            Stop Batch
                        </button>
                    </div> : null}

                </div> : null}
            </div>
            <div className="text-[12px] sm:text-[14px] whitespace-nowrap text-right">
                {batchTime && "Last successful CEIPAL sync:"}{" "}{batchTime && new Date(batchTime).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true
                })}
                {syncStatus?.run && <div className={syncStatus.run.status === "failed" ? "text-red-600" : "text-gray-600"}>
                    {syncStatus.run.status === "running" ? "Sync running" : `Sync ${syncStatus.run.status}`}
                    {syncStatus.run.status === "succeeded" && ` · +${syncStatus.run.inserted_count} added · ${syncStatus.run.updated_count} updated · ${syncStatus.run.deactivated_count} inactive`}
                    {syncStatus.run.status === "failed" && ` · ${syncStatus.run.error_summary || "See server logs"}`}
                    {syncStatus.scoring && ` · AI: ${Number(syncStatus.scoring.pending || 0)} pending, ${Number(syncStatus.scoring.retrying || 0)} retrying, ${Number(syncStatus.scoring.failed || 0)} failed`}
                </div>}
            </div>
        </div>
    );
};

export default Navbar;
